
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { regrasEncantation } from '../../../mocks/worksheet-encantations';

export default function WorksheetHero() {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section className="relative min-h-[85vh] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/daaf2b8eef1052502d87cec916d50f23.jpg"
          alt="Encantations - Crie suas afirmações poderosas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-[#FAF8F5]"></div>
      </div>

      {/* Navbar overlay */}
      <div className="relative z-10 pt-6 px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#F4E4C1] rounded-lg flex items-center justify-center shadow-lg">
              <i className="ri-heart-3-fill text-xl text-[#1a1a1a]"></i>
            </div>
            <span className="text-xl font-bold text-white">Cartas de Gratidão</span>
          </Link>
          <Link
            to="/exercicio/encantations-tony-robbins"
            className="px-5 py-2.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium rounded-full hover:bg-white/20 transition-all whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Voltar ao Exercício
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-24 pb-32 text-center">
        <div className="inline-flex items-center gap-2 px-5 py-2 bg-[#D4AF37]/20 backdrop-blur-sm rounded-full border border-[#D4AF37]/30 mb-8">
          <i className="ri-file-list-3-line text-[#D4AF37]"></i>
          <span className="text-[#D4AF37] text-sm font-medium tracking-wide">Worksheet Interativo</span>
        </div>

        <h1 className="font-['Playfair_Display'] text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Crie Suas <span className="text-[#D4AF37] italic">Encantations</span>
          <br />Personalizadas
        </h1>

        <p className="font-['Montserrat'] text-lg md:text-xl text-white/85 max-w-3xl mx-auto leading-relaxed mb-10 font-light">
          Siga o passo a passo abaixo para criar afirmações poderosas que combinam
          palavras, movimento e emoção — a técnica revolucionária de Tony Robbins
          para reprogramar sua identidade.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="#criar-encantations"
            className="px-8 py-4 bg-[#D4AF37] text-black font-semibold rounded-lg hover:bg-[#C5A028] transition-all duration-300 shadow-lg hover:shadow-xl flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-edit-line text-lg"></i>
            Começar Agora
          </a>
          <button
            onClick={() => setShowVideo(true)}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            O Que São Encantations?
          </button>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-14">
          <div className="text-center">
            <p className="font-['Playfair_Display'] text-3xl font-bold text-[#D4AF37]">6</p>
            <p className="font-['Montserrat'] text-sm text-white/70 mt-1">Regras de Ouro</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="font-['Playfair_Display'] text-3xl font-bold text-[#D4AF37]">8</p>
            <p className="font-['Montserrat'] text-sm text-white/70 mt-1">Áreas da Vida</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="font-['Playfair_Display'] text-3xl font-bold text-[#D4AF37]">21</p>
            <p className="font-['Montserrat'] text-sm text-white/70 mt-1">Dias de Prática</p>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideo && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-6"
          onClick={() => setShowVideo(false)}
        >
          <div
            className="relative bg-stone-900 rounded-2xl overflow-hidden max-w-3xl w-full shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-4 right-4 z-10 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            <div className="p-8">
              <h3 className="font-['Playfair_Display'] text-2xl font-bold text-white mb-4">
                O Que São Encantations?
              </h3>
              <p className="font-['Montserrat'] text-base text-stone-300 mb-6 leading-relaxed">
                Encantations são uma evolução das afirmações tradicionais, criadas por Tony Robbins.
                A diferença fundamental é que Encantations envolvem <strong className="text-[#D4AF37]">todo o seu corpo</strong>:
                você não apenas fala — você <strong className="text-[#D4AF37]">move-se, sente e vive</strong> cada palavra
                com intensidade máxima.
              </p>
              <div className="space-y-4">
                {regrasEncantation.slice(0, 3).map((regra) => (
                  <div key={regra.numero} className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-full bg-[#D4AF37]/20 flex items-center justify-center flex-shrink-0">
                      <i className={`${regra.icone} text-[#D4AF37] text-sm`}></i>
                    </div>
                    <div>
                      <p className="font-['Montserrat'] text-sm font-semibold text-white">{regra.titulo}</p>
                      <p className="font-['Montserrat'] text-sm text-stone-400">{regra.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a
                href="#regras"
                onClick={() => setShowVideo(false)}
                className="inline-flex items-center gap-2 mt-6 text-[#D4AF37] font-medium text-sm hover:underline cursor-pointer"
              >
                Ver todas as 6 regras
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
